import { Injectable, Type } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { GenericRemoteActionBuilderUIStep } from '../remote-action-builder-steps';
import { EmpSelectComponent } from 'src/app/_components/remote-action-step/emp-select/emp-select.component';

@Injectable()
export class EmpSelectRemoteActionBuilderUiStep
  implements GenericRemoteActionBuilderUIStep {
  public isLast: boolean = false;

  constructor(private logger?: LoggingService) {}

  public getComponent(): Type<any> {
    this.logger.log(this.constructor.name, '- getComponent called');
    return EmpSelectComponent;
  }

  public isVisible(currentData: any): boolean {
    // Always Visible
    return true;
  }
}
